import React, { useEffect, useState } from "react";
// import { format, isBefore, startOfYear, subMonths, startOfMonth } from "date-fns";
import {
  // MdArrowDropUp,
  // MdArrowDropDown,
  MdArrowLeft,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { getYear } from "date-fns";

import {
  Container,
  // Search,
  // IconBox,
  // ListContent,
  ListItem,
  // Info,
  // Button,
  // Update,
  Area,
  ItemCourse,
} from "./styles";

import ContentBox from "../../components/UI/ContentBox";
import Banner from "../../components/UI/Banner";
// import InputSearch from "../../components/UI/Inputs/InputSearch";
// import CardItem from "../../components/UI/CardItem";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import ReadMoreButton from "../../components/UI/ReadMoreButton"
import FullScreenLoading from "../../components/UI/FullScreenLoading";

import useApi from "../../hooks/useApi";
// import { useAuth } from "../../hooks/useAuth";

// import { images, icons } from "../../constants";

const CoursesManagerList = () => {
  // const { user } = useAuth();
  const navigate = useNavigate();
  const [coursesList, setCoursesList] = useState([]);
  const [segmentList, setSegmentList] = useState([]);
  const [year, setYear] = useState(null);
  const [segment, setSegment] = useState({categoryName:"Não Selecionado",segment:"none"});
  const [listYear, setListYear] = useState([2024,2025]);
  const [alert, setAlert] = useState(null);

  const [loadCourse, loadCourseInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/course/activities/coursesByUser",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        // console.log("course by user", response.data);
        let temp = response.data.filter((course)=>{
          return course.isEditor || course.isTutor;
        });
        console.log("temp", temp);
        if(temp.length===0){
          if(year!==null){
            setAlert(`Você não é editor ou tutor de nenhuma atividade do ano de ${year}`)
          }
        }
        
        if(temp.length<=10){
          setSegment({categoryName:"Todos",segment:"all"});
        }
        else{
          let listSeg = [];
          temp.forEach((course)=>{
            if(listSeg.findIndex((seg)=>{return seg.segment===course.segment})<0){
              listSeg.push({categoryName:course.categoryName,segment:course.segment});
            }
          });
          console.log("lista de segmentos",listSeg);
          if(listSeg.length>1){
            setSegmentList(listSeg);
          }else{
            setSegment({categoryName:"Todos",segment:"all"});
          }
        }
        setCoursesList(temp);
        setAlert(null);
      }
    },
  });

  useEffect(() => {
    setListYear([getYear(new Date())-1,getYear(new Date())])
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
      if(year!==null){
        loadCourse({params:{hasSubscription:true, year}});
      }
      //eslint-disable-next-line
    }, [year]);



  // const controlList = (typeChange=0, segmentChange=0)=>{
  //   let list = [];
  //   coursesList.forEach((type)=>{
  //     if(segmentChange!==0){
  //       if(type.courseType===typeChange){
  //         type.segments.forEach((segment)=>{
  //           if(segment.segment===segmentChange){
  //             if(segment.open){
  //               segment.open=false;
  //             }
  //             else{
  //               segment.open=true;
  //             }
  //           }
  //         })
  //       }
  //     }
  //     else{
  //       if(type.courseType===typeChange){
  //         if(type.open){
  //           type.open=false;
  //         }
  //         else{
  //           type.open=true;
  //         }
  //       }
  //     }
  //     list.push(type);
  //   })
  //   setCoursesList(list);
  // };

  const filterSegment = (course)=> {
    if(segment.segment==="all"){
      return true;
    }
    else{
      return segment.segment===course.segment;
    }
  };

  return (
    <Container>
      {loadCourseInfo.loading && <FullScreenLoading />}
      <Menu />
      <Banner
        // icon={images.iconNovidades}
      >
        Gestão de atividades dos cursos
      </Banner>

      {/* <Search>
        <InputSearch
          value={search}
          onChange={handleSearch}
          onClick={handleSearch}
        />
      </Search> */}

      <ContentBox>
        <Area visible={true}>
          <ListItem border={true} 
                  roundborder={true} 
                  pointer={true} 
                  row={true} 
                  reduct={0} 
                  visible={true} 
                  selected={true} 
                  onClick={()=>{navigate("/formacoes/manager");}}
          >
            <MdArrowLeft fontSize={36}/> Voltar para gestão de formação
          </ListItem>

          {year!==null && <ListItem border={true} 
                  roundborder={true} 
                  pointer={true} 
                  row={true} 
                  reduct={0} 
                  visible={true} 
                  selected={true} 
                  onClick={()=>{setSegment({categoryName:"Não Selecionado",segment:"none"});setSegmentList([]);setYear(null);}}
          >
            <MdArrowLeft fontSize={36}/> {year}
          </ListItem>}
          {year!==null && (segment.segment!=="none" && segment.segment!== "all") && <ListItem border={true} 
                  roundborder={true} 
                  pointer={true} 
                  row={true} 
                  reduct={0} 
                  visible={true} 
                  selected={true} 
                  onClick={()=>{setSegment({categoryName:"Não Selecionado",segment:"none"})}}
          >
            <MdArrowLeft fontSize={36}/> {segment.categoryName}
          </ListItem>}

          {
            year===null && <>
              {listYear.map((item)=>(
                <ListItem row={true} border={true} key={item} onClick={()=>{setYear(item)}} visible={true} reduct={0} roundborder={true} selected={false}>
                  {item}
                </ListItem>
              ))}
            </>
          }

          {
            alert && <>{alert}</>
          }

          {
            year!==null && segmentList.length>1 && segment.segment==="none" && <>
              {segmentList.map((item)=>(
                <ListItem row={true} border={true} key={item.segment} onClick={()=>{setSegment({categoryName:item.categoryName,segment:item.segment})}} visible={true} reduct={0} roundborder={true} selected={false}>
                  {item.categoryName}
                </ListItem>
              ))}
            </>
          }

          {coursesList.filter(filterSegment).map((course)=>(
                    course.hasSubscription && <ItemCourse
                      key={course.id} 
                      visible={true}
                      reduct={0}
                      roundborder={false}>
                      <div className="text">{course.title}</div> 
                      <div className="button">
                        <div>
                          <ReadMoreButton onClick={()=>{navigate(`/coursemanager/${course.id}`)}} text="Gestão de atividades" />
                        </div>
                        <div>
                          <ReadMoreButton onClick={()=>{navigate(`/courseregistermanager/${course.id}`)}} text="Registro de atividades" />
                        </div>
                      </div>
                    </ItemCourse>
                  ))}
        </Area>
      </ContentBox>

      <Footer />
    </Container>
  );
};

export default CoursesManagerList;
